import React, { useEffect } from 'react'
import { dateFormatLocal, formatString, successMessageToast } from "helpers/common";
import { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { CLIENT_REPORTS_LIST, NOTES_TABLE } from "config/paths";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import LoadingOverlay from "components/shared/LoadingOverlay";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { useFavouriteReportMutation, useGetClientDetailReportsListQuery, useGetClientReportsListQuery } from "store/services/resource";
import { CommonSelect, CommonToolTip, CstmPagination } from "components/Common/Common";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import styles from './myfavorite.module.scss'
import { useCopyReportsMutation, useDeleteClientReportMutation } from 'store/services/clients/reports-v2/schoolReports';
import { CLIENT_REPORT_TYPES, reportDateFormat, REPORTS_FILTER_OPTIONS } from 'config/constants';
import { Star } from 'react-feather';
import moment from 'moment';
import ClassroomReportDateModal from 'components/Modals/ClassroomReportDateModalV2';
import rightArrow from "Assets/images/rightArro.png"
import downArrow from 'Assets/images/downArrowPurple.png'
import upArrow from 'Assets/images/upArrowPurple.png'
import downArrowNormal from 'Assets/images/downArro.png'
import ClientsReportMenu from 'components/shared/ReportComponents/ClientsReportMenu';
import { useGetClientDetailsQuery } from 'store/services/misc';
import ReportSendModal from './ReportSendModal';
import { usePublishDocumentMutation } from 'store/services/clients/attachment';
import { useSelector } from 'react-redux';
import { ThreeDotsMenuIcon } from 'Assets/icons/v2';


const ReportsComponent = ({ clientId, clientType, isPage, setClientDetails }) => {
    const navigate = useNavigate()
    const userInfo = useSelector((state) => state.auth.user)
    console.log(userInfo, "userInfo-")
    const [currentEntry, setCurrentEntry] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [filter, setFilter] = useState({ status: isPage ? { label: "All", value: "" } : { label: "Published", value: "complete" } })
    const [currentPage, setCurrentPage] = useState(1)
    const pageSize = 10
    const [copyReportDateModal, setCopyReportDateModal] = useState(false)
    const disabled = false
    const [openRow, setOpenRow] = useState(null);
    const [reportModal, setReportModal] = useState(false);
    const [reportSingleData, setReportSingleData] = useState([]);
    const [reportId, setReportId] = useState(null);

    const toggleRow = (id) => setOpenRow(openRow === id ? null : id);

    // notes
    const { data, isLoading, isFetching, isError, refetch } = useGetClientDetailReportsListQuery({ id: clientId, limit: isPage ? 10 : 6, ...filter, page: currentPage, published: true })
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [deleteReport, { isLoading: deleteReportLoading }] = useDeleteClientReportMutation()
    const [copyReport, { isLoading: copyReportLoading }] = useCopyReportsMutation()
    const [favouriteReport, { isLoading: favouriteReportLoading }] = useFavouriteReportMutation()
    const [publishResource, { isLoading: publishResourceLoading }] = usePublishDocumentMutation();

    const { data: clientDetails } = useGetClientDetailsQuery({ clientId, clientType }, { refetchOnMountOrArgChange: true });

    const column = [
        {
            head: <div onClick={() => setFilter((prev) => ({ ...prev, sort: prev?.sort?.column == "is_favorite" ? { column: "id", direction: "DESC" } : { column: "is_favorite", direction: "DESC" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
            accessor: "is_favorite",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.id, item?.is_favorite ? 0 : 1) }}>{item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
            ),
        },
        {
            head: "Report Type",
            accessor: "assesment_type",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.assesmentType?.title || "--"}</h6>
            ),
        },
        {
            head: "Report Date",
            accessor: "screening_date",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{dateFormatLocal(item?.screening_date, "MMM DD, YYYY")}</h6>
            ),

        },
        {
            head: "Status",
            accessor: "status",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 style={{ fontStyle: "italic" }} className="m-0 fw-bold themeBlue text-capitalize">{item?.status == "processing" ? "In Progress" : item?.status == "complete" ? "Published" : item?.status}</h6>
            ),

        },

        {
            head: "Discipline",
            accessor: "is_published",
            isComponent: true,
            component: (item, ind) => (
                <span className={`discipline-${item?.Therapist?.therapist_detail?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.Therapist?.therapist_detail?.therapist_discipline?.assign_term}</span>
            ),
        },
        {
            head: "Created By",
            accessor: "is_published",
            isComponent: true,
            component: (item, ind) => (
                <span style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{formatString(item?.Therapist?.therapist_detail?.type)}</span>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => {
                const loggedInType = userInfo?.role_type;
                const rowCreatedBy = item?.Therapist?.id;
                const isOwner = rowCreatedBy === userInfo?.id;
                return (
                    <div className="ActnBtn d-flex align-items-center  gap-10">
                        {

                            <Dropdown
                                onClick={(e) => e.stopPropagation()}
                            // show={index == dropdownIndex}
                            // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
                            >
                                <Dropdown.Toggle
                                    variant="transparent"
                                    className="p-0 border-0 text-dark w-100"
                                    id="dropdown-basic"
                                >
                                    <ThreeDotsMenuIcon />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                                    <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                        {
                                            item?.status == "complete" && <>

                                                <h5 className="cursor-pointer proxima mb-0" onClick={() => {
                                                    console.log("item", item);
                                                    setReportModal(true)
                                                    if (item.emailFormData) {
                                                        setReportSingleData(JSON.parse(item.emailFormData)?.recipientList)
                                                        setReportId(item?.id)
                                                    }
                                                }} style={{ padding: "7px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Resend</h5>
                                                {
                                                    clientType === "school" &&
                                                    <h5 className="proxima mb-0"
                                                        style={{ padding: "7px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}
                                                    onClick={(e) => handlePublish(e, item?.pdfList?.[0]?.id, item?.pdfList?.[0]?.is_published === "yes")}
                                                    >
                                                        {item?.pdfList?.[0]?.is_published === "yes" ? "Unpublish" : "Publish"}
                                                    </h5>
                                                }
                                            </>
                                        }
                                        {
                                            item?.status != "complete" &&
                                            <>
                                                <h5 className="cursor-pointer proxima mb-0" onClick={(e) => { handleCopyReport(e, item?.id, item?.assesment_type,); setCurrentEntry(item) }} style={{ borderBottom: "0.5px solid #000", opacity: disabled && "0.5", padding: "7px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Make a Copy</h5>
                                                {/* {
                                                    isApprentice && !isOwner ? "" :
                                                        <h5 className="cursor-pointer proxima mb-0" onClick={(e) => { handleDelete(e, item?.id, item?.assesment_type) }} style={{ padding: "13px 0", fontSize: "14px", opacity: disabled && "0.5", fontWeight: 500, color: "#071E3E" }}>Delete</h5>
                                                } */}
                                                {(loggedInType === "veteran" || isOwner) && (
                                                    <h5
                                                        className="cursor-pointer proxima mb-0"
                                                        onClick={(e) => handleDelete(e, item?.id, item?.assesment_type)}
                                                        style={{
                                                            padding: "13px 0",
                                                            fontSize: "14px",
                                                            opacity: disabled && "0.5",
                                                            fontWeight: 500,
                                                            color: "#071E3E"
                                                        }}
                                                    >
                                                        Delete
                                                    </h5>
                                                )}


                                            </>
                                        }

                                    </ul>
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                        {
                            item?.status == "complete" && <div
                                className="cursor-pointer d-flex align-items-center"
                                style={{ padding: "10px 10px" }}
                                onClick={(e) => {
                                    e.stopPropagation(); // prevent row navigation
                                    toggleRow(item.id);
                                }}
                            >
                                {openRow === item.id ? (
                                    <img width={12} src={downArrow} alt="Collapse" />
                                ) : (
                                    <img width={7} src={rightArrow} alt="Expand" />
                                )}
                            </div>
                        }
                    </div>
                )
            }
        },
    ]

    const handleFilterChange = (key) => (value) => {
        setFilter((prev) => ({ ...prev, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleDelete = async (e, reportId, assessmentId) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE NOTE",
            message: "Are you sure you want to delete this note?",
        });
        if (!isConfirm) {
            return;
        }
        const reportType = CLIENT_REPORT_TYPES[assessmentId]?.copyType
        try {
            const result = await deleteReport({ clientType, reportId, reportType }).unwrap()
            console.log('result of delete', result)
            successMessageToast(result?.message)
        } catch (error) {
            console.log('error', error)
        }
    }

    const handleCopyReportApi = async (reportId, assessmentId, screening_date) => {
        const reportType = CLIENT_REPORT_TYPES[assessmentId]?.copyType
        try {
            await copyReport({ clientId, clientType, reportId, reportType, assessmentId, screening_date }).unwrap()
            if (copyReportDateModal) {
                setCopyReportDateModal(false)
            }
        } catch (error) {
            console.log('error copying report:', error)
        }
    }
    const handleCopyReport = async (e, reportId, assessmentId) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "MAKE A COPY",
            message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
        });
        if (!isConfirm) {
            setCopyReportDateModal(true)
            return
        }
        else {
            handleCopyReportApi(reportId, assessmentId, moment(new Date()).format("YYYY-MM-DD"))
        }
    }

    const handleFavouriteReport = async (id, favorite) => {
        const data = {
            favorite
        }
        try {
            await favouriteReport({ data, id }).unwrap()
        } catch (error) {
            console.log('error making the client favourite: ', error)
        }
    }

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handlePublish = async (e, resourceId, is_published) => {
        try {

            e.stopPropagation();
            if (publishResourceLoading) return;
            const isConfirm = await confirmDialogV2({
                title: `${is_published ? "UNPUBLISH" : "PUBLISH"} REPORT`,
                message: `Are you sure you want to ${is_published ? "unpublish" : "publish"} this report on the ${clientType === "school" ? "Teacher" : "Parent"} dashboard?`,
            });
            if (!isConfirm) {
                return
            }

            const result = await publishResource({ clientId, resourceId })
            if (result?.error) return;

            typeof refetch == "function" && refetch();
            successMessageToast(result?.data?.message);

            // const list = cloneDeep(reports);
            // const record = list?.find(x => x?.id == resourceId);
            // record.is_published = record.is_published === "yes" ? "no" : "yes";

            // setReports(list);
        } catch (err) { console.log("Error publishing Resource") };
    };


    useEffect(() => {
        if (clientDetails && typeof (setClientDetails) == 'function') {
            setClientDetails(clientDetails)
        }
    }, [clientDetails])

    return (
        <>
            <section
                className={`position-relative ClientDetail`}
            >
                <div className="" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

                    <Row className="justify-content-between align-items-end" >
                        <Col lg='6'>
                            {
                                isPage ?
                                    <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                        All Reports
                                    </p>
                                    :
                                    <h6 onClick={() => navigate(generatePath(CLIENT_REPORTS_LIST, { clientId, clientType }))} className="mb-0 proxima-regular" style={{ marginTop: "3px" }}>REPORTS
                                        <span className="themePurple cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span>
                                    </h6>
                            }
                        </Col>
                        <Col lg='5'>

                            <div className="d-flex gap-5">
                                <div className="w-100 reports-v2 my-3 d-flex justify-content-end classroom-conslutation">

                                    <div className="d-flex w-100 align-items-center gap-3">
                                        <label className="discharge-screen-label mb-0">Status</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={isPage ? [{ label: "All", value: "" }, ...REPORTS_FILTER_OPTIONS] : REPORTS_FILTER_OPTIONS}
                                            onChange={(e) => handleFilterChange("status")(e)}
                                            value={filter?.status}
                                            isFilterV2
                                            // isClearable
                                            // isLoading={schoolListLoading || schoolListFetching}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%", // ✅ Ensures the whole Select container is full width
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                                <ClientsReportMenu
                                    disabled={['active', 'incoming']?.includes(clientDetails?.status) ? false : true}
                                    client_type={clientType}
                                    v2={true}
                                    isButton={true}
                                    index={0}
                                    client={{ client_detail: { client_type: clientType }, id: clientId }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {<div className="w-100">
                    <ClassroomReportDateModal
                        show={copyReportDateModal}
                        setShow={setCopyReportDateModal}
                        currentEntry={currentEntry}
                        handleCopyReportApi={handleCopyReportApi}
                        isLoading={copyReportLoading}
                        type='school'
                    />
                    {(isFetching || favouriteReportLoading || deleteReportLoading || copyReportLoading || publishResourceLoading) && <LoadingOverlay />}

                    <div className="mt-2">
                        <TableLayout
                            clientId={clientId}
                            clientType={clientType}
                            userInfo={userInfo}
                            height={'unset'}
                            data={data?.records || []}
                            column={column}
                            filter={filter}
                            handleSort={handleFilterChange("sort")}
                            openRow={openRow}
                            expandableRowComponent={(row) => {
                                let emailData = {};
                                try {
                                    emailData = JSON.parse(row?.emailFormData || '{}');
                                } catch (error) {
                                    console.error('Invalid JSON in emailFormData', error);
                                }
                                const date = moment(row?.publishedAt).format("MMM DD, YYYY");
                                const time = moment(row?.publishedAt).format("h:mm A");
                                return (
                                    <div style={{ borderTop: "0.25px solid #00000036", paddingTop: "8px" }} className="d-flex gap-3 justify-content-between">
                                        <table style={{ width: "70%", borderCollapse: "separate", borderSpacing: "0 6px" }}>
                                            <tbody>
                                                <tr className="border-0">
                                                    <th className="border-0 p-0 text-left">Dashboard:</th>
                                                    <td className="border-0 p-0">Teacher</td>
                                                </tr>
                                                <tr className="border-0">
                                                    <th className="border-0 p-0 text-left">Email Recipient:</th>
                                                    <td className="border-0 p-0">
                                                        {
                                                            emailData?.recipientList?.map(item => `${item?.email} `)
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="text-end d-flex text-gray-500" style={{ width: "30%", gap: "30px", paddingTop: "6px" }}>
                                            <p>{date || "--"}</p>
                                            <p>{time || "--"}</p>
                                        </div>
                                    </div>
                                )
                            }}
                        />
                        {
                            isPage && <div className='py-2'>
                                <CstmPagination
                                    totalPages={totalPages}
                                    className={'paginationV2'}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        }
                    </div>
                </div >}

                <ReportSendModal guardians={clientDetails?.client_detail?.client_guardian_mapping} show={reportModal} setShow={setReportModal} data={reportSingleData} reportId={reportId} />

            </section>
        </>
    );

};

export default ReportsComponent;


const TableLayout = ({ openRow, toggleRow, clientType, clientId, expandableRowComponent, userInfo, column, data, url, showHeader = true, noDataMsg = "Data not found", state, filter, handleRowClick, height, handleSort }) => {
    const navigate = useNavigate();

    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    // const { data: consentFormList, error, isLoading: consentFormListLoading } = useGetConsentformListQuery({ client_id: clientId });

    const handleSortClick = (item) => {

        let sort = {};
        console.log('filter sort and item?.accessor', filter, item?.accessor)
        if (filter?.sort?.column == item?.accessor) {

            if (filter?.sort?.direction == "asc") sort = { column: item?.accessor, direction: "desc" };
            else sort = { column: "id", direction: "desc" };

        } else sort = { column: item?.accessor, direction: "asc" }

        typeof handleSort === "function" && handleSort(sort);
    };

    const handleViewPdf = async (name) => {

        try {
            const result = await getFileUrl(name);
            if (result?.error) return;

            const url = result?.data
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };



    return (
        <div className="favorite-goal-wrapper classroom-consultation proxima table_height" style={{ height: height || "calc(100vh - 220px)" }}>
            {
                getFileFetching && <LoadingOverlay />
            }
            <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
                <table className={`${styles.table} table`}>
                    {showHeader && (
                        <thead>
                            <tr className="">
                                {column &&
                                    column.length > 0 &&
                                    column.map((item, key) => (
                                        <>
                                            <th className="text-dark border-0" style={{ fontWeight: 500 }}>
                                                <div className={`d-flex ${filter?.sort?.column == item?.accessor && "themePurple"}`}>
                                                    {item.head}
                                                    {
                                                        item?.sorter && <div className="px-2 cursor-pointer d-flex flex-column justify-content-center" onClick={() => handleSortClick(item)}>
                                                            {filter?.sort?.column == item?.accessor && filter?.sort?.direction?.toLowerCase() == "asc" && <img width={9} height={9} className="ms-2" src={upArrow} alt="downArrow" />}
                                                            {filter?.sort?.column == item?.accessor && filter?.sort?.direction?.toLowerCase() == "desc" && <img width={9} height={9} className="ms-2" src={downArrow} alt="downArrow" />}
                                                            {filter?.sort?.column != item?.accessor && <img width={9} height={6} className="ms-2" src={downArrowNormal} alt="downArrow" />}
                                                        </div>
                                                    }
                                                </div>
                                            </th>
                                        </>
                                    ))}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((row, idx) => (
                                <React.Fragment key={row.id || idx}>
                                    {/* Main Row */}
                                    <tr
                                        className={`${url ? "cursor-pointer" : ""}`}
                                        onClick={(e) => {
                                            if (row?.pdfList?.[0]?.attachment_key)
                                                handleViewPdf(row?.pdfList?.[0]?.attachment_key);
                                            else {
                                                const loggedInType = userInfo?.role_type;
                                                const isApprentice = loggedInType === "apprentice";

                                                const rowCreatedBy = row?.Therapist?.id; // or therapist_detail.user_id
                                                const isOwner = rowCreatedBy === userInfo?.id;

                                                if (clientType != 'chatter') {
                                                    if (isApprentice && !isOwner) {
                                                        console.log("Access denied");
                                                        return;
                                                    }
                                                }

                                                // url && navigate(`${url}/${row.id}`, { state }); 
                                                navigate(generatePath(CLIENT_REPORT_TYPES[row?.assesment_type].path, { clientType, clientId, assessmentId: row?.assesment_type, reportId: row?.id }))
                                                handleRowClick?.(row);
                                            }
                                        }}
                                    >
                                        {column?.map((item, key) => (
                                            <td
                                                key={key}
                                                className={`${row?.status === "copied"
                                                    ? "copied-report-bcg"
                                                    : row?.status === "complete" && "published-report-bcg"
                                                    } ${openRow == row?.id && 'border-bottom-0 rounded-bottom-0'} `}
                                            >
                                                {item.component
                                                    ? item.component(row, idx, row)
                                                    : row[item?.accessor] || "--"}
                                            </td>
                                        ))}
                                    </tr>

                                    {/* Expanded Row */}
                                    {expandableRowComponent && openRow === row.id && (
                                        <tr style={{ position: 'relative', top: "-10px" }}>
                                            <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={2}></td>
                                            <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={7}>
                                                {expandableRowComponent(row)}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={column?.length || 1} className="text-center">
                                    {noDataMsg}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};